import React from 'react';
import Button from '../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactMenuPosition,
} from '../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {DropdownMenuCompactTileProps} from '../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompactTile';
import {Option} from '../../components/common/MultiSelect';
import {SingleSelect} from '../../components/common/SingleSelect';

export interface ButtonAction {
    type: 'button';
    label: string;
    icon: string;
    onClick: () => void;
    disabled?: boolean;
    hidden?: boolean;
}

export interface DropdownAction {
    type: 'dropdown';
    label: string;
    icon: string;
    disabled?: boolean;
    hidden?: boolean;
    items: DropdownMenuCompactTileProps[][];
}

export interface SelectAction {
    type: 'select';
    label: string;
    options: Option[];
    value?: string;
    onChange: (value: string | undefined) => void;
    disabled?: boolean;
    hidden?: boolean;
    isClearable?: boolean;
}

export type GeneratorAction = ButtonAction | DropdownAction | SelectAction;

interface GeneratorActionsProps {
    leftActions?: GeneratorAction[];
    rightActions?: GeneratorAction[];
}

function renderAction(action: GeneratorAction, index: number): JSX.Element | null {
    if (action.hidden) return null;

    if (action.type === 'dropdown') {
        return (
            <DropdownMenuCompact key={index} items={action.items} menuPosition={DropdownMenuCompactMenuPosition.UP}>
                <Button size="sm" variant="ghost" color="secondary" leading={action.icon} disabled={action.disabled}>
                    {action.label}
                </Button>
            </DropdownMenuCompact>
        );
    }

    if (action.type === 'select') {
        const selectedOption = action.options.find((option) => option.value === action.value) ?? null;

        return (
            <div key={index} className="c-generatorPage__select">
                <SingleSelect
                    options={action.options}
                    value={selectedOption}
                    onChange={(option) => action.onChange(option?.value)}
                    disabled={action.disabled}
                    isClearable={action.isClearable}
                    placeholder={action.label}
                    menuPlacement="top"
                />
            </div>
        );
    }

    return (
        <Button
            key={index}
            size="sm"
            variant="ghost"
            color="secondary"
            leading={action.icon}
            onClick={action.onClick}
            disabled={action.disabled}
        >
            {action.label}
        </Button>
    );
}

export default function GeneratorActions({leftActions = [], rightActions = []}: GeneratorActionsProps): JSX.Element {
    return (
        <div className="c-generatorPage__actions">
            <div className="u-flex u-gap-2">{leftActions.map(renderAction)}</div>
            <div className="u-flex u-gap-2">{rightActions.map(renderAction)}</div>
        </div>
    );
}
